export const FETCHING_ALLOCATION_UNITS = 'FETCHING_ALLOCATION_UNITS';
export const FETCH_ALLOCATION_UNITS_SUCCESS = 'FETCH_ALLOCATION_UNITS_SUCCESS';
export const CREATING_ALLOCATION_UNIT = 'CREATING_ALLOCATION_UNIT';
export const CREATE_ALLOCATION_UNIT_SUCCESS = 'CREATE_ALLOCATION_UNIT_SUCCESS';
export const RESET_ALLOCATION_UNIT = 'RESET_ALLOCATION_UNIT';
export const UPDATING_ALLOCATION_UNIT = 'UPDATING ALLOCATION UNIT';
export const UPDATE_ALLOCATION_UNIT_SUCCESS = 'UPDATE ALLOCATION UNIT SUCCESS';
export const DELETING_ALLOCATION_UNIT = 'DELETING ALLOCATION UNIT';
export const DELETE_ALLOCATION_UNIT_SUCCESS = 'DELETE ALLOCATION UNIT SUCCESS';
export const DELETE_ALLOCATION_UNIT_FAILED = 'DELETE ALLOCATION UNIT FAILED';
export const RESET_DELETE_FAILED_FLAG = 'RESET DELETE FAILED FLAG';
export const FETCHING_ALLOCATION_UNIT = 'FETCHING ALLOCATION UNIT';
export const FETCH_ALLOCATION_UNIT_SUCCESS = 'FETCH ALLOCATION UNIT SUCCESS';
export const FETCH_ALL_ALLOCATION_UNITS_SUCCESS = 'FETCH_ALL_ALLOCATION_UNITS_SUCCESS';
export const FETCHING_ALL_ALLOCATION_UNITS = 'FETCHING_ALL_ALLOCATION_UNITS';
export const SELECT_COST_OBJ_ALLOCATION_UNIT = 'SELECT_COST_OBJ_ALLOCATION_UNIT';


// WEBPACK FOOTER //
// ./src/redux/allocationUnits/AllocationUnitsConstants.js